module.exports = __webpack_public_path__ + "static/media/logo.191b028b.jpg";